export default __webpack_public_path__ + "static/media/Oxford.83f451ad.png";